<template>
  <div class="row">
    <div class="col py-3">
      <div v-if="!busy" class="row">
        <div v-if="!isMobile" class="col-md-12 col-xl-8 mb-3 mb-xxl-0">
          <b-tabs
            content-class="card__worktypes bg-white"
          >
            <b-tab
              :title="$t('Select your lead types')"
              :title-link-class="'first-tab'"
            >
              <work-type-list
                v-model="selectedWorkTypes"
                :class="'h-100 mx-0'"
                :workTypes="allWorkTypes"
                @click="activateWt"
              />
            </b-tab>
            <b-tab
              :title="$t('Search for lead types')"
              class="card__worktypes"
              :title-link-class="'last-tab'"
            >
              <work-type-search v-model="selectedWorkTypes" :workTypes="allWorkTypes" @click="activateLs" />
            </b-tab>
          </b-tabs>
        </div>
        <div v-if="isMobile && !showBasket" class="col-12 d-xxl-none mb-3 mb-lg-0 card__worktypes">
          <b-card
            class="card__worktypes__card bg-white border rounded-bottom overflow-hidden h-100 shadow"
            no-body
          >
            <b-card-header :class="{'card-bottom__accent': activeWt}">
              {{ $t('Select your lead types') }}
            </b-card-header>
            <b-card-body class="card__worktypes-body">
              <work-type-list v-model="selectedWorkTypes" :class="'h-100'" :workTypes="allWorkTypes"
                              @click="activateWt"
              />
            </b-card-body>
          </b-card>
        </div>
        <div v-if="(isTablet || isDesktop) || showBasket" class="col-12 col-xl-4 col-xxl-4 card__worktypes">
          <b-card class="card__worktypes__card bg-white border shadow rounded-bottom overflow-hidden h-100" no-body>
            <b-card-header>{{ $t('Lead types selected') }}</b-card-header>
            <div v-if="selectedWorkTypes.length === 0" class="mt-5 pt-2 col-12">
              <div class="position-relative worktype-placeholder">
                <h2 class="h4 font-italic font-weight-light text-center">
                  {{ $t('Selected lead types will display here') }}
                </h2>
              </div>
            </div>
            <basket v-else v-model="selectedWorkTypes" />
          </b-card>
        </div>
      </div>
      <spinner v-else :display-loading="true" />
    </div>
  </div>
</template>

<script>
import Basket from "@/components/tabs/coverage/worktypes/Basket";
import WorkTypeList from "@/components/tabs/coverage/worktypes/WorkTypeList";
import WorkTypeSearch from "@/components/tabs/coverage/worktypes/WorkTypeSearch";
import Spinner from "@/components/animation/Spinner";
import userDevice from "@/imports/mixins/userDevice";
import notification from "@/imports/mixins/notification";

export default {
  name: "WorkTypes",
  components: {Spinner, WorkTypeSearch, WorkTypeList, Basket},
  mixins: [userDevice, notification],
  props: ['coverage'],
  data: function () {
    return {
      selectedWorkTypes: [],
      dataLoaded: 2,
      newArea: false,
      cleanState: null,
      initial: true,
      activeWt: false,
      activeLs: false,
      showBasket: false,
    }
  },
  computed: {
    coverageWorkTypes: function () {
      return this.$store.state.coverage.COVERAGE_WORK_TYPES;
    },
    allWorkTypes: function () {
      return this.$store.state.coverage.WORK_TYPES;
    },
    busy: function () {
      return this.dataLoaded < 2;
    },
    preventSave: function () {
      return this.selectedWorkTypes.length < 1 || this.busy;
    },
    coverageList: function(){
      return this.$store.state.coverage.COVERAGE_LIST;
    },
    lastCoverage: function() {
      return this.coverageList.length === 1;
    }
  },
  methods: {
    activateWt: function () {
      this.activeLs = false;
      this.activeWt = true;
    },
    activateLs: function () {
      this.activeLs = true;
      this.activeWt = false;
    },
    loadWorkTypes: function () {
      this.dataLoaded--;
      this.$store.dispatch('getAllWorkTypes').then(() => {
        this.dataLoaded++
      });
    },
    loadCoverageWorkTypes: function () {
      this.dataLoaded--;
      this.$store.dispatch('getCoverageWorkTypes', this.coverage.id).then(() => {
        this.dataLoaded++
      });
    },
    saveWorkTypes: function () {
      this.dataLoaded--;
      this.$api.coverage.updateWorkTypes(this.coverage.id, this.selectedWorkTypes).then(() => {
        this.$store.dispatch('updateGlobals');
        this.loadCoverageWorkTypes();
        this.dataLoaded++;
        this.cleanState = true;
        this.$emit('isSaving', true);
      });
    },
    save: function () {
      this.saveWorkTypes();
    },
    switchBasket: function () {
      this.showBasket = !this.showBasket;
    }
  },
  watch: {
    coverage: function () {
      this.loadCoverageWorkTypes();
    },
    coverageWorkTypes: function () {
      if (this.coverageWorkTypes.length < 1) {
        this.newArea = true;
      }
      this.initial = true;
      this.selectedWorkTypes = [...this.coverageWorkTypes];
    },
    selectedWorkTypes: function (value) {
      if (this.initial) {
        this.initial = false;
        this.cleanState = true;
      } else {
        this.cleanState = false;
        if (this.lastCoverage && value.length < 1) {
          this.notify(
            this.$bvToast,
            this.$t(`Removing all lead types will disable your listing`),
            null,
            'warning'
          );
        }
      }
    },
    cleanState: function (value) {
      this.$emit('clean', value);
    },
  },
  created: function () {
    this.loadWorkTypes();
    this.loadCoverageWorkTypes();
  },
}
</script>

<style scoped lang="scss">
.card {
  &__worktypes {
    border: 0;
    min-height: 190px;
    @include media-breakpoint-down(lg) {
      margin-bottom: 30px
    }
    &-body {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
}
</style>
